import React from 'react';
import { Route } from 'react-router';
import CompanyRegulation from './screens/CompanyRegulation/router';
import RegulationManagement from './screens/RegulationManagement/router';
export default (
  <Route
    getComponent={(location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('./index'));
      });
    }}
  >
    {CompanyRegulation}
    {RegulationManagement}
  </Route>
);



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/CompanyRules/router.js
 **/